function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M9.502 20.677l3.62 4.62-5.102 3.118M23.069 3.646h4.64c1.203 0 2.187 1.251 2.187 2.453v9.943a2.194 2.194 0 0 1-2.187 2.187H7.292a2.193 2.193 0 0 1-2.187-2.187V6.099c0-1.202.983-2.453 2.187-2.453h4.64M11.931 3.646L15.114.729h4.773l3.182 2.917M32.528 16.042c1.115.879 1.742 1.87 1.742 2.916 0 3.432-6.734 6.273-15.312 6.563"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M13.12 25.295C5.98 24.543.73 21.99.73 18.96c0-1.042.62-2.025 1.722-2.9"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  strokeLinejoin: "round",
  d: "M21.146 10.208a3.645 3.645 0 1 1-7.29.001 3.645 3.645 0 0 1 7.29 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M25.52 7.292a.73.73 0 1 0 .001 1.459.73.73 0 0 0 0-1.46"
}));

var SvgCameraSelfieIcon = function SvgCameraSelfieIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 29,
    viewBox: "0 0 35 29",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCameraSelfieIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/camera_selfie_icon.3746d308.svg";
export { ForwardRef as ReactComponent };